<script>
import consentService from '@services/consent-service'
import BaseButton from './_base-button'

export default {
    name: 'ConsentBanner',
    components: {
        BaseButton
    },
    data() {
        return {
            isVisible: true
        }
    },
    mounted() {
        document.addEventListener('keydown', this.handleKeydown)
        document.addEventListener('click', this.handleDocumentClick, true)
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeydown)
        document.removeEventListener('click', this.handleDocumentClick, true)
    },
    methods: {
        handleAgree() {
            consentService.grantConsent('banner')
            this.$emit('close')
        },
        handleTemporaryDismiss() {
            this.isVisible = false
        },
        handleKeydown(event) {
            if (event.key === 'Escape') {
                this.handleTemporaryDismiss()
            }
        },
        handleDocumentClick(event) {
            if (this.isVisible && this.$refs.banner && !this.$refs.banner.contains(event.target)) {
                this.handleTemporaryDismiss()
            }
        }
    }
}
</script>

<template>
    <div
        v-if="isVisible"
        ref="banner"
        :class="$style.banner"
        role="dialog"
        aria-modal="false"
        aria-label="Privacy consent"
    >
        <p :class="$style.text">
            By using this site, you agree to our
            <a
                :class="$style.link"
                href="https://frisky.fm/about/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
            >Privacy Policy</a>.
        </p>
        <BaseButton
            button-type="secondaryPink"
            size="small"
            :modifiers="{ noMargins: true }"
            @click="handleAgree"
        >
            I agree
        </BaseButton>
    </div>
</template>

<style lang="scss" module>
@use '@design' as *;

.banner {
    position: fixed;
    bottom: $s-m;
    left: 50%;
    z-index: $layer-modal-z-index;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: $s-l;
    width: calc(100% - #{$s-m} * 2);
    padding: $s-l;
    background-color: $c-shark-grey;
    border-radius: $size-input-border-radius;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
    transform: translateX(-50%);
}

.text {
    @extend %contentSubtitleM;

    margin: 0;
    color: $c-white;
}

.link {
    color: $c-white;
    text-decoration: underline;

    &:hover {
        color: $c-highlight;
    }
}

@include desktop {
    .banner {
        bottom: $s-xl;
        right: $s-xl;
        left: auto;
        width: auto;
        max-width: 480px;
        transform: none;
    }
}
</style>
